import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { UserSatisfaction as Block } from "./UserSatisfactionBlock";
import { defaultData } from "./UserSatisfactionDefaultData";
import imagePreview from "./user_satisfaction_preview.png";

export const UserSatisfactionBlock: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "User Satisfaction",
    version: 1,
    nameI18n: "builder_ui.block_type.user_satisfaction",
    isHidden: true,
    props: {
      content: {
        name: "Content",
        nameI18n: "builder_ui.prop_type.content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
        type: "children",
      },
    },
  },
};
